export const wrapTex = {
  "4162-W3050-0002": {
    repeat_x: 0.0052,
    repeat_y: 0.0082,
    rot: 0,
  },
  "4162-W600-0101": {
    repeat_x: 0.0052,
    repeat_y: 0.0082,
    rot: 0,
  },
  "6065-W010-0004": {
    repeat_x: 0.0052,
    repeat_y: 0.0082,
    rot: 0,
  },
  "4162-W3052-0121": {
    repeat_x: 0.0052,
    repeat_y: 0.0082,
    rot: 0,
  },
  "3601-W7300-0008": {
    repeat_x: 0.352,
    repeat_y: 0.382,
    rot: 0,
  },
  "3095-W4522-0011": {
    repeat_x: 0.352,
    repeat_y: 0.382,
    rot: 0,
  },
  "6656S-W21916-008": {
    repeat_x: 0.252,
    repeat_y: 0.282,
    rot: 0,
  },
  "2317H-W21363-0001": {
    repeat_x: 0.082,
    repeat_y: 0.102,
    rot: 0,
  },
  "3081-W040-0101": {
    repeat_x: 0.082,
    repeat_y: 0.102,
    rot: 0,
  },
  "2751-W1080-0011": {
    repeat_x: 0.08,
    repeat_y: 0.03,
    rot: 0,
  },
  "6065-W010-0014": {
    repeat_x: 0.0072,
    repeat_y: 0.0102,
    rot: 0,
  },
  "2317H-W21774-0001": {
    repeat_x: 0.152,
    repeat_y: 0.182,
    rot: 0,
  },
  "6625-W043-0002": {
    repeat_x: 0.152,
    repeat_y: 0.182,
    rot: 0,
  },
  "FM62015-15B": {
    repeat_x: 0.352,
    repeat_y: 0.382,
    rot: 0,
  },

  "FL48479-302B": {
    repeat_x: 0.0142,
    repeat_y: 0.0192,
    rot: 0,
  },
  "FL46491-11B": {
    repeat_x: 0.0142,
    repeat_y: 0.0192,
    rot: 0,
  },

  "FL48479-10B": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },
  "FL34766-1A": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },
  "FL48875-13C": {
    repeat_x: 0.72,
    repeat_y: 0.22,
    rot: 0,
  },
  "FL53948-11C": {
    repeat_x: 0.92,
    repeat_y: 0.002,
    rot: 0,
  },
  "FL53278-15B": {
    repeat_x: 0.42,
    repeat_y: 0.0002,
    rot: 0,
  },
  "FL53085-17B": {
    repeat_x: 0.42,
    repeat_y: 0.0002,
    rot: 0,
  },
  "FL28927-13C": {
    repeat_x: 0.42,
    repeat_y: 0.0002,
    rot: 0,
  },
  "FL51168-1A": {
    repeat_x: 0.42,
    repeat_y: 0.0002,
    rot: 0,
  },
  "FL28927-17C": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },
  "FL55551-13B": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },
  "FL51284-13C": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },
  "FL57122-13B": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },
  "FM47350-31B": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },
  "FL42657-1A": {
    repeat_x: 0.42,
    repeat_y: 0.0002,
    rot: 0,
  },

  "FL44018-5494B": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },
  "FL34766-1188B": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },
  "FM304596-10B": {
    repeat_x: 0.0042,
    repeat_y: 0.0092,
    rot: 0,
  },
  "FM404193-11B": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },
  "FM33268-1A": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },
  "FM47397-1A": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },

  "FM51243-13B": {
    repeat_x: 0.72,
    repeat_y: 0.22,
    rot: 0,
  },
  //
  "FL46491-14B": {
    repeat_x: 0.01,
    repeat_y: 0.01,
    rot: 0,
  },
  "FL46491-11B": {
    repeat_x: 0.01,
    repeat_y: 0.01,
    rot: 0,
  },
  "FL46491-19B": {
    repeat_x: 0.3,
    repeat_y: 0.3,
    rot: 0,
  },
  "FL28927-13C": {
    repeat_x: 0.3,
    repeat_y: 0.3,
    rot: 0,
  },
  "FL48479-13B": {
    repeat_x: 0.3,
    repeat_y: 0.3,
    rot: 0,
  },
  "FL44018-8821": {
    repeat_x: 1.3,
    repeat_y: 1.3,
    rot: 0,
  },
  "FM39508-13B": {
    repeat_x: 0.5,
    repeat_y: 0.9,
    rot: 0,
  },
  "FM56924-11C": {
    repeat_x: 0.08,
    repeat_y: 0.08,
    rot: -45,
  },
  "FM11997-13B": {
    repeat_x: 0.12,
    repeat_y: 0.12,
    rot: 0,
  },
  "FM17023-17B": {
    repeat_x: 0.52,
    repeat_y: 0.52,
    rot: 0,
  },
  "FM69867-81B": {
    repeat_x: 0.12,
    repeat_y: 0.42,
    rot: 0,
  },
  "FM54953-11B": {
    repeat_x: 1.62,
    repeat_y: 1.92,
    rot: 0,
  },
  "FL51284-13C": {
    repeat_x: 0.092,
    repeat_y: 0.092,
    rot: 0,
  },
  "FL33331-19B": {
    repeat_x: 0.42,
    repeat_y: 0.92,
    rot: 0,
  },
  "FM404193-11B": {
    repeat_x: 0.8,
    repeat_y: 0.8,
    rot: 0,
  },
  "FM34766-1209": {
    repeat_x: 0.8,
    repeat_y: 0.8,
    rot: 0,
  },
  "FL66893-1A": {
    repeat_x: 0.0158,
    repeat_y: 0.0158,
    rot: 0,
  },
  "FL48479-13B": {
    repeat_x: 1.42,
    repeat_y: 1.42,
    rot: 0,
  },
  "FL55546-13B": {
    repeat_x: 1.202,
    repeat_y: 1.202,
    rot: 0,
  },
  "FM69867-11B": {
    repeat_x: 0.42,
    repeat_y: 0.42,
    rot: 0,
  },
  "FM69867-81B": {
    repeat_x: 0.12,
    repeat_y: 0.42,
    rot: 0,
  },


  "5557-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0082,
    rot: 0,
  },
  "5543-102A": {
    repeat_x: 0.0052,
    repeat_y: 0.0088,
    rot: 0,
  },
  "5602-102A": {
    repeat_x: 0.0052,
    repeat_y: 0.0035,
    rot: 0,
  },
  "5558-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0045,
    rot: 0,
  },
  "5574-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0052,
    rot: 0,
  },
  "5555-101B": {
    repeat_x: 0.0052,
    repeat_y: 0.0045,
    rot: 0,
  },
  "5550-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0052,
    rot: 0,
  },
  "5595-101B": {
    repeat_x: 0.0052,
    repeat_y: 0.0052,
    rot: 0,
  },
  "5682-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0052,
    rot: 0,
  },
  "5592-102A": {
    repeat_x: 0.0052,
    repeat_y: 0.0052,
    rot: 0,
  },
  "5718-240": {
    repeat_x: 0.0052,
    repeat_y: 0.0052,
    rot: 0,
  },
  "5677-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0035,
    rot: 0,
  },
  "5626-101B": {
    repeat_x: 0.0052,
    repeat_y: 0.0035,
    rot: 0,
  },
  "5006-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0062,
    rot: 0,
  },
  "4943-102A": {
    repeat_x: 0.0052,
    repeat_y: 0.0062,
    rot: 0,
  },
  "4845-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0052,
    rot: 0,
  },
  "4881-101A": {
    repeat_x: 0.0032,
    repeat_y: 0.0072,
    rot: 0,
  },
  "4942-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0052,
    rot: 0,
  },
  "4930-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0062,
    rot: 0,
  },
  "4943-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0062,
    rot: 0,
  },
  "4927-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0052,
    rot: 0,
  },
  "4942-102A": {
    repeat_x: 0.0052,
    repeat_y: 0.0052,
    rot: 0,
  },
  "4808-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0052,
    rot: 0,
  },
  "4972-101A": {
    repeat_x: 0.0052,
    repeat_y: 0.0062,
    rot: 0,
  },
  "3601-W1230-0021": {
    repeat_x: 0.032,
    repeat_y: 0.032,
    rot: 0,
  },
  "3091-W030-0387": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "5882S-W24409-0002": {
    repeat_x: 0.042,
    repeat_y: 0.042,
    rot: 0,
  },
  "2420-W831-0008": {
    repeat_x: 0.022,
    repeat_y: 0.022,
    rot: 0,
  },
  "Zaffiro-16": {
    repeat_x: 0.032,
    repeat_y: 0.032,
    rot: 0,
  },
  "3601-W7360-0008": {
    repeat_x: 0.032,
    repeat_y: 0.032,
    rot: 0,
  },
  "2420-W021-0008": {
    repeat_x: 0.032,
    repeat_y: 0.032,
    rot: 0,
  },
  "3601-W8880-0002": {
    repeat_x: 0.032,
    repeat_y: 0.032,
    rot: 0,
  },
  "3601-W7360-0007": {
    repeat_x: 0.032,
    repeat_y: 0.032,
    rot: 0,
  },
  "3985H-W24275-0001": {
    repeat_x: 0.03,
    repeat_y: 0.03,
    rot: 0,
  },
  "3985H-W24271-0001": {
    repeat_x: 0.035,
    repeat_y: 0.035,
    rot: 0,
  },
  "2640-W20800-0011": {
    repeat_x: 0.18,
    repeat_y: 0.18,
    rot: 0,
  },
  "2420-W841-0271": {
    repeat_x: 0.075,
    repeat_y: 0.075,
    rot: 0,
  },
  "Savoy-99": {
    repeat_x: 0.032,
    repeat_y: 0.032,
    rot: 0,
  },
  "Duca-208": {
    repeat_x: 0.012,
    repeat_y: 0.012,
    rot: 0,
  },
  "3985-W1610-0015": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3978-W010-0061": {
    repeat_x: 0.009,
    repeat_y: 0.009,
    rot: 0,
  },
  "2420-W021-0001": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "2420-W021-0006": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "2420-W021-0005": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "2420-W841-0001": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "2420-W831-0001": {
    repeat_x: 0.34,
    repeat_y: 0.34,
    rot: 0,
  },
  "2420-W831-0271": {
    repeat_x: 0.034,
    repeat_y: 0.034,
    rot: 0,
  },
  "2420-W841-0008": {
    repeat_x: 0.084,
    repeat_y: 0.084,
    rot: 0,
  },
  "3601-W1210-0021": {
    repeat_x: 0.24,
    repeat_y: 0.24,
    rot: 0,
  },
  "3601-W1210-0003": {
    repeat_x: 0.24,
    repeat_y: 0.24,
    rot: 0,
  },
  "3601-W8880-0009": {
    repeat_x: 0.64,
    repeat_y: 0.64,
    rot: 0,
  },
  "3601-W3600-0004": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "3601-W1230-0041": {
    repeat_x: 0.54,
    repeat_y: 0.54,
    rot: 0,
  },
  "3601-W8880-0008": {
    repeat_x: 0.54,
    repeat_y: 0.54,
    rot: 0,
  },
  "3601-W7360-0003": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "3090-W1074-0003": {
    repeat_x: 0.74,
    repeat_y: 0.74,
    rot: 0,
  },
  "3601-W3600-0007": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "3601-W7360-0005": {
    repeat_x: 0.2,
    repeat_y: 0.2,
    rot: 0,
  },
  "3090-W11000-0001": {
    repeat_x: 0.44,
    repeat_y: 0.44,
    rot: 0,
  },
  "3601-W1230-0003": {
    repeat_x: 0.44,
    repeat_y: 0.44,
    rot: 0,
  },
  "3601-W7350-0005": {
    repeat_x: 1.14,
    repeat_y: 1.14,
    rot: 0,
  },
  "3601-W7350-0006": {
    repeat_x: 1.14,
    repeat_y: 1.14,
    rot: 0,
  },
  "3601-W1230-0031": {
    repeat_x: 0.44,
    repeat_y: 0.44,
    rot: 0,
  },
  "3601-W8880-0004": {
    repeat_x: 0.74,
    repeat_y: 0.74,
    rot: 0,
  },
  "3601-W7350-0008": {
    repeat_x: 1.44,
    repeat_y: 1.44,
    rot: 0,
  },
  "3601-W1230-0061": {
    repeat_x: 0.44,
    repeat_y: 0.44,
    rot: 0,
  },
  "3601-W7360-0004": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "3601-W8880-0011": {
    repeat_x: 0.74,
    repeat_y: 0.74,
    rot: 0,
  },
  "3601-W7350-0004": {
    repeat_x: 1.14,
    repeat_y: 1.14,
    rot: 0,
  },
  "3601-W3600-0001": {
    repeat_x: 0.14,
    repeat_y: 1,
    rot: 0,
  },
  "3601-W3600-0003": {
    repeat_x: 0.14,
    repeat_y: 1,
    rot: 0,
  },
  "3601-W7350-0003": {
    repeat_x: 1.4,
    repeat_y: 1.4,
    rot: 0,
  },
  "4343-W20720-0004": {
    repeat_x: 0.3,
    repeat_y: 0.3,
    rot: 0,
  },
  "4343-W20720-0001": {
    repeat_x: 0.3,
    repeat_y: 0.3,
    rot: 0,
  },
  "6459-W13470-0003": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "6459-W13470-0002": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "6459-W13470-0001": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "6459-W13440-0003": {
    repeat_x: 0.74,
    repeat_y: 0.74,
    rot: 0,
  },
  "6459-W13440-0002": {
    repeat_x: 0.74,
    repeat_y: 0.74,
  },
  "6459-W13440-0001": {
    repeat_x: 0.74,
    repeat_y: 0.74,
    rot: 0,
  },
  "4343-W20720-0002": {
    repeat_x: 0.28,
    repeat_y: 0.28,
    rot: 0,
  },
  "Zaffiro 14": {
    repeat_x: 0.2,
    repeat_y: 0.2,
    rot: 0,
  },
  "2420-W841-0271": {
    repeat_x: 0.18,
    repeat_y: 0.18,
    rot: 0,
  },
  "2420-W831-0008": {
    repeat_x: 0.38,
    repeat_y: 0.38,
    rot: 0,
  },
  "3985-W1610-0011": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3494-W010-0039": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3985-W1610-0101": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3494-W010-0011": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3985-W1610-0027": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3494-W010-0017": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3985-W1610-0282": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "7906-W3930-0480": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3985-W1610-0051": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3978-W010-0031": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3985-W1610-0023": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3985-W1610-0285": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3985-W1610-0142": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3985-W1610-0017": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3985-W1610-0291": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3985-W1610-0014": {
    repeat_x: 0.0092,
    repeat_y: 0.0092,
    rot: 0,
  },
  "3095-W10870-0011": {
    repeat_x: 1.92,
    repeat_y: 1.92,
    rot: 0,
  },
  "3092-W040-0052": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "3130-W050-0052": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "3120-W020-0111": {
    repeat_x: 0.62,
    repeat_y: 0.62,
    rot: 0,
  },
  "3091-W030-1817": {
    repeat_x: 0.62,
    repeat_y: 0.62,
    rot: 0,
  },
  "3206-W010-0130": {
    repeat_x: 0.62,
    repeat_y: 0.62,
    rot: 0,
  },
  "3091-W030-1840": {
    repeat_x: 0.62,
    repeat_y: 0.62,
    rot: 0,
  },
  "3601-W7290-0003": {
    repeat_x: 0.62,
    repeat_y: 1,
    rot: 0,
  },
  "3120-W020-0114": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "3120-W010-0151": {
    repeat_x: 1.92,
    repeat_y: 1.92,
    rot: 0,
  },
  "3601-W7290-0002": {
    repeat_x: 0.52,
    repeat_y: 1,
    rot: 0,
  },
  "3206-W010-0014": {
    repeat_x: 0.52,
    repeat_y: 1,
    rot: 0,
  },
  "3090-W020-2279": {
    repeat_x: 1.92,
    repeat_y: 1.92,
    rot: 0,
  },
  "3090-W020-2633": {
    repeat_x: 1.92,
    repeat_y: 1.92,
    rot: 0,
  },
  "3090-W020-0151": {
    repeat_x: 1.92,
    repeat_y: 1.92,
    rot: 0,
  },
  "3130-W050-0101": {
    repeat_x: 1.92,
    repeat_y: 1.92,
    rot: 0,
  },
  "3090-W020-0101": {
    repeat_x: 1.92,
    repeat_y: 1.92,
    rot: 0,
  },
  "3095-W10870-0101": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "3091-W030-1830": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3090-W020-0221": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3130-W050-1227": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3092-W040-1817": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3120-W020-0012": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3206-W010-0101": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3091-W030-0151": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3091-W030-0101": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3120-W020-0024": {
    repeat_x: 0.82,
    repeat_y: 2,
    rot: 0,
  },
  "3601-W7290-0001": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3090-W020-2614": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3092-W040-0101": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3206-W010-0126": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3130-W050-1217": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3130-W050-0103": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3206-W010-0084": {
    repeat_x: 0.32,
    repeat_y: 0.32,
    rot: 0,
  },
  "3120-W010-0053": {
    repeat_x: 0.32,
    repeat_y: 0.32,
    rot: 0,
  },
  "3100-W012-0031": {
    repeat_x: 0.82,
    repeat_y: 0.82,
    rot: 0,
  },
  "3100-W012-0013": {
    repeat_x: 1.52,
    repeat_y: 1.52,
    rot: 0,
  },
  "3100-W012-0014": {
    repeat_x: 1.52,
    repeat_y: 1.52,
    rot: 0,
  },
  "3100-W012-0012": {
    repeat_x: 1.32,
    repeat_y: 1.32,
    rot: 0,
  },
  "6459-W5810-0016": {
    repeat_x: 0.7,
    repeat_y: 0.7,
    rot: 0,
  },
  "6459-W13450-0001": {
    repeat_x: 1.7,
    repeat_y: 1.7,
    rot: 0,
  },
  "4343-W20711-0001": {
    repeat_x: 1.2,
    repeat_y: 1.2,
    rot: 0,
  },
  "3091-W032-2010": {
    repeat_x: 1.2,
    repeat_y: 1.2,
    rot: 0,
  },
  "3091-W032-2011": {
    repeat_x: 1.2,
    repeat_y: 1.2,
    rot: 0,
  },
  "3097-W11001-0001": {
    repeat_x: 0.8,
    repeat_y: 0.8,
    rot: 0,
  },
  "3097-W1072-0003": {
    repeat_x: 1.2,
    repeat_y: 0.6,
    rot: 0,
  },
  "3340-W3380-0001": {
    repeat_x: 0.8,
    repeat_y: 0.8,
    rot: 0,
  },
  "4343-W20781-0001": {
    repeat_x: 1.2,
    repeat_y: 0.6,
    rot: 0,
  },
  "4343-W19641-0001": {
    repeat_x: 1.3,
    repeat_y: 1.3,
    rot: 0,
  },
  "4343-W20711-0002": {
    repeat_x: 1.2,
    repeat_y: 0.9,
    rot: 0,
  },
  "1623-002": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "1623-403": {
    repeat_x: 0.14,
    repeat_y: 0.14,
    rot: 0,
  },
  "1554-849": {
    repeat_x: 0.2,
    repeat_y: 0.2,
    rot: 0,
  },
  "1621-488": {
    repeat_x: 0.2,
    repeat_y: 0.2,
    rot: 0,
  },
  "1623-035": {
    repeat_x: 0.2,
    repeat_y: 0.2,
    rot: 0,
  },
  "1623-665": {
    repeat_x: 0.2,
    repeat_y: 0.2,
    rot: 0,
  }, 
  "1623-488": {
    repeat_x: 0.2,
    repeat_y: 0.2,
    rot: 0,
  }, 
  "1554-002": {
    repeat_x: 0.32,
    repeat_y: 0.02,
    rot: 0,
  },
  "1554-035": {
    repeat_x: 0.2,
    repeat_y: 0.2,
    rot: 0,
  }, 
  "1554-403": {
    repeat_x: 0.32,
    repeat_y: 0.32,
    rot: 0,
  }, 
  "1554-665": {
    repeat_x: 0.32,
    repeat_y: 0.98,
    rot: 0,
  }, 
  "1554-488": {
    repeat_x: 0.32,
    repeat_y: 0.62,
    rot: 0,
  }, 
  "6065-W010-0101": {
    repeat_x: 0.2,
    repeat_y: 0.2,
    rot: 0,
  },
  "6065-W010-0001": {
    repeat_x: 0.03,
    repeat_y: 0.03,
    rot: 0,
  },
  "6065-W010-0006": {
    repeat_x: 0.03,
    repeat_y: 0.03,
    rot: 0,
  },
  "6065-W010-0009": {
    repeat_x: 0.03,
    repeat_y: 0.03,
    rot: 0,
  },
  "6065-W010-0005": {
    repeat_x: 0.052,
    repeat_y: 0.092,
    rot: 0,
  },
  "6065-W010-0014": {
    repeat_x: 0.032,
    repeat_y: 0.032,
    rot: 0,
  },
  "6065-W010-0004": {
    repeat_x: 0.032,
    repeat_y: 0.032,
    rot: 0,
  },
  "0260-W030-0101": {
    repeat_x: 0.2,
    repeat_y: 0.2,
    rot: 0,
  },
  "0260-W030-0028": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "0260-W030-0114": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "0260-W030-0111": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "1285-W0022-0101": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "1285-W0022-0003": {
    repeat_x: 0.52,
    repeat_y: 0.52,
    rot: 0,
  },
  "1288-W0030-0101": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "1288-W0030-0003": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "1279-W0250-0001": {
    repeat_x: 0.4,
    repeat_y: 0.4,
    rot: 0,
  },
  "1279-W0250-0002": {
    repeat_x: 0.4,
    repeat_y: 0.4,
    rot: 0,
  },
  "3206-W010-0127": {
    repeat_x: 1,
    repeat_y: 1,
    rot: 0,
  },
  "5906D-W010-0236": {
    repeat_x: 0.42,
    repeat_y: 0.42,
    rot: 0,
  },  
  "5906D-W010-0201": {
    repeat_x: 0.62,
    repeat_y: 0.002,
    rot: 0,
  },  
  "5906D-W010-0204": {
    repeat_x: 0.82,
    repeat_y: 0.002,
    rot: 0,
  },  
  "5906D-W010-0225": {
    repeat_x: 0.82,
    repeat_y: 0.002,
    rot: 0,
  },  
  "5906D-W010-0218": {
    repeat_x: 0.82,
    repeat_y: 0.002,
    rot: 0,
  }, 
  "5906D-W010-0234": {
    repeat_x: 0.82,
    repeat_y: 0.002,
    rot: 0,
  },   
  "5906D-W010-0206": {
    repeat_x: 0.82,
    repeat_y: 0.002,
    rot: 0,
  },   
  "2331-W3181-0001": {
    repeat_x: 0.092,
    repeat_y: 0.092,
    rot: 0,
  },
  "2331-W3191-0001": {
    repeat_x: 0.042,
    repeat_y: 0.042,
    rot: 0,
  },
  "2331-W3181-0002": {
    repeat_x: 0.092,
    repeat_y: 0.092,
    rot: 0,
  },
  "2331-W3191-0002": {
    repeat_x: 0.042,
    repeat_y: 0.042,
    rot: 0,
  },
  "2702-W0252-0471": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "2702-W0252-0262": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "2702-W0252-0482": {
    repeat_x: 0.52,
    repeat_y: 0.22,
    rot: 0,
  },
  "2702-W0252-0511": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "2702-W0252-0501": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "2702-W0252-0581": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "2702-W0252-0551": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "2702-W0252-0531": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
  "2702-W0252-0075": {
    repeat_x: 0.92,
    repeat_y: 0.92,
    rot: 0,
  },
};

export const wrapCont = {
  "0": {
    repeat_x: 0.1,
    repeat_y: 0.1,
  },
  "1": {
    repeat_x: 0.025,
    repeat_y: 0.025,
  },
  "2": {
    repeat_x: 0.095,
    repeat_y: 0.095,
  },
  "3": {
    repeat_x: 0.065,
    repeat_y: 0.065,
  },
};
